import { Injectable, Injector } from "@angular/core";
import { Service } from "@services/service";

@Injectable()
export class AuditService extends Service {
	constructor(injector: Injector) {
		super("Audits", injector);
	}
}